import pr_vedphotomake from '../../assets/pr_vedphotomake.png'
import pr_food from '../../assets/pr_food.png'
import pr_travel from '../../assets/pr_travel.png'
import pr_calculator from '../../assets/pr_calculator.png'
import pr_type from '../../assets/pr_type.png'
import pr_lottery from '../../assets/pr_lottery.jpg'
import pr_word from '../../assets/pr_word.png'
import pr_jokes from '../../assets/pr_jokes.png'
import pr_todo from '../../assets/pr_todo.png'
import pr_webpro from '../../assets/pr_webpro.png'
import pr_jobportal from '../../assets/pr_jobportal.png'

export const projectData = [
  {
    id: 1,
    image: pr_vedphotomake,
    title: 'Photo Studio Website',
    category: 'web',
    tech: ' React.js | CSS | Firebase',
    link: 'https://vedphotomake.web.app/',
    github: 'https://github.com/vedantpatil25/vedphotomake',
    description: '',
  },
  {
    id: 2,
    image: pr_jobportal,
    title: 'CareerConnect - Job Portal',
    category: 'web',
    tech: ' React.js | CSS ',
    link: 'https://careerconnectbyvedant.web.app/',
    github: 'https://github.com/vedantpatil25/career-connect',
  },
  {
    id: 3,
    image: pr_travel,
    title: 'Travel Booking System',
    category: 'app',
    tech: ' Java Swing | SQL | JDBC Connectivity ',
    link: 'https://github.com/vedantpatil25/Ticket-booking-system',
    github: 'https://github.com/vedantpatil25/Ticket-booking-system',
  },
  {
    id: 4,
    image: pr_lottery,
    title: ' Lottery System |  Blockchain ',
    category: 'app',
    tech: ' Solidity | React | Typescript | Thirdweb',
    link: 'https://github.com/vedantpatil25/Blockchain-Lottery-System',
    github: 'https://github.com/vedantpatil25/Blockchain-Lottery-System',
    description:
      'This is a blockchain-based lottery system built using Next.js and Tailwind CSS. The system allows users to buy lottery tickets and participate in the lottery. The system is built on the Ethereum blockchain using smart contracts.',
  },
  {
    id: 5,
    image: pr_type,
    title: 'TypingiT - Practice Typing',
    category: 'web',
    tech: ' HTML | CSS | Javascript',
    link: 'https://typingt-by-vedant.netlify.app/',
    github: 'https://github.com/vedantpatil25/TypingiT-Typing-Game',
  },
  {
    id: 6,
    image: pr_word,
    title: ' Word Counter',
    category: 'app',
    tech: ' HTML | CSS | Javascript ',
    link: 'https://word-counter-by-vedant.netlify.app/',
    github: 'https://github.com/vedantpatil25/Word-counter',
  },
  {
    id: 7,
    image: pr_todo,
    title: 'To-do List',
    category: 'web',
    tech: ' HTML | CSS | Javascript-localStorage',
    link: 'https://todo-list-by-vedant.netlify.app/',
    github: 'https://github.com/vedantpatil25/To-do-List',
  },
  {
    id: 8,
    image: pr_food,
    title: 'Restaurant Menu',
    category: 'web',
    tech: ' React.js | CSS ',
    link: 'https://food-court-12b40.web.app/',
    github: 'https://github.com/vedantpatil25/Food-App',
  },

  {
    id: 9,
    image: pr_jokes,
    title: 'Jokes using API',
    category: 'web',
    tech: ' HTML | CSS | Javascript | API ',
    link: 'https://jokes-using-api.netlify.app/',
    github: 'https://github.com/vedantpatil25/Jokes-Using-API',
  },

  {
    id: 10,
    image: pr_webpro,
    title: 'Courses Static Website',
    category: 'web',
    tech: ' HTML | CSS ',
    link: 'https://webpro-courses.netlify.app/',
    github: 'https://github.com/vedantpatil25/webPro-courses-static-website',
  },
  {
    id: 11,
    image: pr_calculator,
    title: 'Calculator',
    category: 'design',
    tech: ' HTML | CSS | Javascript ',
    link: 'https://calculator-by-vedant.netlify.app/',
    github: 'https://github.com/vedantpatil25/Calculator-App',
  },
]
